import React from 'react'
import LogoText from '../../assets/images/gymcorelogo.png'

interface CardScreenProps {
    children?: React.ReactNode
    title?: string
}

const CardScreen: React.FC<CardScreenProps> = ({ children, title }) => {
    return (
        <div className='bg-light flex min-h-screen items-center justify-center md:px-8 md:py-6 font-Inter'>
            <div className='relative flex flex-col h-screen justify-evenly md:justify-center w-full bg-white md:rounded-[12px] md:h-auto md:w-[560px] gap-3 md:gap-8 py-8 px-5 md:px-16'>

                <div className='flex justify-center '>
                    <div style={{ backgroundImage: `url("${LogoText}")` }} className='bg-cover w-80 h-40  rounded-md bg-center'>
                    </div>
                </div>
                <h1 className='text-2xl text-center text-dark font-semibold'>{title}</h1>

                {children}
            </div>
        </div>
    )
}

export default CardScreen